import type { ProcessedBetEntry } from "@/hooks/firestore/betting/useEntries";
import React from "react";
import { BetSelectionAutomation } from "./BetSelectionAutomation";

interface PromotionProps {
  entry: ProcessedBetEntry;
  isPreview?: boolean;
}

const Promotion = ({ entry, isPreview }: PromotionProps) => {
  const progressions = entry.data.automationProgressions;
  const isShared = !!entry.shareId;

  if (isShared || isPreview || !progressions?.length) return null;

  return progressions.map(({ progressionId }) => (
    <BetSelectionAutomation
      key={`automation-${progressionId}`}
      entry={entry}
      progressionId={progressionId}
    />
  ));
};

export { Promotion };
